import { ShieldCheck } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PaymentFailed = () => {
const { t } = useTranslation();
  return (
      <main className='grid place-items-center h-[60dvh]'>
      <div className="bg-white p-10 text-center max-w-[400px] w-full">
        <div className="bg-[#f8d7da] rounded-full w-20 h-20 flex justify-center items-center mx-auto mb-4">
            <ShieldCheck size={46} color='red'/>
          </div>
          <h1 className='text-xl font-semibold'>{t('routes.payment-failed')}</h1>
          <p>
          {t('training-courses.failed-p')}
          </p>
          <Link to="/training-courses?page=1" className='px-12 py-2 rounded-md bg-primary-tw text-white '>
          {t('training-courses.back-to-courses')}
          </Link>
        </div>
    </main>
  );
};
export default PaymentFailed;
